import { TableRow, TableCell, Typography } from '@mui/material';

const TableEmptyState = ({ colSpan, message }) => (
  <TableRow>
    <TableCell colSpan={colSpan} align='center' sx={{ py: 8 }}>
      <Typography variant='body1' color='text.secondary'>
        {message}
      </Typography>
    </TableCell>
  </TableRow>
);

export default TableEmptyState;
